import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { MyQuizzesList } from "./MyQuizzesList";
import { QuizTakingView } from "./QuizTakingView";
import { getQuizzes } from "@/features/quizzes/api";
import type { Quiz } from "@/features/quizzes/types";
import type { QuizHelperRequest } from "@/types/quizHelpers";

interface QuizIntroScreenProps {
  userId: string;
  contentId?: string | null;
  onHelperRequest?: (req: QuizHelperRequest) => void;
}

export const QuizIntroScreen: React.FC<QuizIntroScreenProps> = ({
  userId,
  contentId,
  onHelperRequest
}) => {
  const [activeQuiz, setActiveQuiz] = useState<Quiz | null>(null);

  // Fetch quizzes to check if any exist
  const { data: quizzes } = useQuery({
    queryKey: ["quizzes", userId, contentId],
    queryFn: () => getQuizzes(userId, contentId),
    enabled: !!userId,
  });

  const hasQuizzes = quizzes && quizzes.length > 0;

  const handleOpenQuiz = (quiz: Quiz) => {
    setActiveQuiz(quiz);
  };
  const handleBack = () => {
    setActiveQuiz(null);
  };
  const handleRestart = () => {
    // Re-trigger the component by resetting and re-setting the quiz
    const quiz = activeQuiz;
    setActiveQuiz(null);
    setTimeout(() => setActiveQuiz(quiz), 0);
  };
  const handleGenerateMore = () => {
    // TODO: Could open the edit modal or trigger regeneration
    setActiveQuiz(null);
  };

  // If a quiz is active, show the taking view
  if (activeQuiz) {
    return <div className="h-full px-4 sm:px-0">
        <QuizTakingView quiz={activeQuiz} onBack={handleBack} onRestart={handleRestart} onGenerateMore={handleGenerateMore} onHelperRequest={onHelperRequest} />
      </div>;
  }
  return <div className="h-full overflow-y-auto px-4 sm:px-0">
      <div className="mx-auto mb-10 w-full max-w-3xl">
        <div className="space-y-6 pt-4">
          {/* Intro Message - only show when no quizzes exist */}
          {!hasQuizzes && (
            <div className="py-5 text-center">
              <p className="text-muted-foreground">
                Ask Shattara AI to create quizzes to see them here.
              </p>
            </div>
          )}

          {/* My Quizzes */}
          <div className="space-y-3">
            <h3 className="text-sm font-medium text-primary/80">My Quizzes</h3>
            <MyQuizzesList userId={userId} contentId={contentId} onOpenQuiz={handleOpenQuiz} />
          </div>
        </div>
      </div>
    </div>;
};